module.exports = __webpack_public_path__ + "media/svg/vector-difference-f4528246.svg";